import { PortalEnvironment } from './environment.model';

export const environment: PortalEnvironment = {
  production: false,
  name: 'dev',
  relayEnvironmentName: 'dev'
};
